import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { OrganizationManagementPort, CreateOrganizationData, UpdateOrganizationData } from '../../domain/ports/OrganizationManagementPort';
import { RepositoryError } from '../../domain/errors';
import { ILoggerService } from '../../domain/services/LoggerService';

export class FirebaseOrganizationManagementAdapter implements OrganizationManagementPort {
  private readonly prefix = 'organizations';
  private readonly logger: ILoggerService;

  constructor(logger: ILoggerService) {
    this.logger = logger;
  }

  async createOrganization(data: CreateOrganizationData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-createOrganization`;
    this.logger.logRepositoryRequest('OrganizationManagementAdapter', 'createOrganization', { functionName, data });

    try {
      const createOrganizationFn = httpsCallable(functions, functionName);
      const result = await createOrganizationFn(data);

      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('OrganizationManagementAdapter', 'createOrganization', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('OrganizationManagementAdapter', 'createOrganization', duration, error);
      console.error('Create organization error:', error);

      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }

      throw RepositoryError.queryFailed();
    }
  }

  async updateOrganization(data: UpdateOrganizationData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-updateOrganization`;
    this.logger.logRepositoryRequest('OrganizationManagementAdapter', 'updateOrganization', { functionName, data });

    try {
      const updateOrganizationFn = httpsCallable(functions, functionName);
      const result = await updateOrganizationFn(data);

      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('OrganizationManagementAdapter', 'updateOrganization', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('OrganizationManagementAdapter', 'updateOrganization', duration, error);
      console.error('Update organization error:', error);

      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }

      throw RepositoryError.queryFailed();
    }
  }
}
